import { useState, useEffect } from "react";
import Input from "../../material/input/Input";
import Select from "../../material/select/Select";
import * as publicApi from "../../../service/publicApi";
import Map from "../../material/map/Map";

const LaboratoryRegistration = ({
  laboratoryName,
  setLaboratoryName,
  labAddress,
  setLabAddress,
  labMoo,
  setLabMoo,
  labSoy,
  setLabSoy,
  labRoad,
  setLabRoad,

  labProvinceId,
  setLabProvinceId,

  labDistrictId,
  setLabDistrictId,

  labSubDistrictId,
  setLabSubDistrictId,

  labPostCode,
  setLabPostCode,

  latitude,
  setLatitude,
  longitude,
  setLongitude,
  regex,
}) => {
  const [labProvinceList, setLabProvinceList] = useState([]);
  const [labDistrictList, setLabDistrictList] = useState([]);
  const [disabledLabDistrict, setDisabledLabDistrict] = useState(true);
  const [labSubDistrictList, setLabSubDistrictList] = useState([]);
  const [disabledLabSubDistrictList, setDisabledLabSubDistrictList] =
    useState(true);

  const getProvinceList = async () => {
    try {
      let res = await publicApi.getProvinceList();
      if (res["data"]["code"] === 200) {
        setLabProvinceList(
          res["data"]["province_list"].map((item) => {
            return {
              key: item["province_id"],
              value: item["province_name"],
            };
          }),
        );
      }
    } catch (error) {
      console.error("Error province catch");
    }
  };

  const getLabDistrictList = async (id) => {
    try {
      let res = await publicApi.getDistrictList(id);
      if (res["data"]["code"] === 200) {
        setDisabledLabDistrict(false);
        setLabDistrictList(
          res["data"]["district_list"].map((item) => {
            return {
              key: item["district_id"],
              value: item["district_name"],
            };
          }),
        );
      }
    } catch (error) {
      console.error("Error district catch");
    }
  };

  const getLabSubDistrictList = async (id) => {
    try {
      let res = await publicApi.getSubDistrictList(id);
      if (res["data"]["code"] === 200) {
        setDisabledLabSubDistrictList(false);
        setLabSubDistrictList(
          res["data"]["sub_district_list"].map((item) => {
            return {
              key: item["sub_district_id"],
              value: item["sub_district_name"],
            };
          }),
        );
      }
    } catch (error) {
      console.error("Error sub district catch");
    }
  };

  useEffect(() => {
    const fetchAPI = async () => {
      await getProvinceList();
    };

    fetchAPI();
  }, []);

  return (
    <div className="max-w-[1000px] mx-auto mt-8">
      <div className="text-[16px] leading-6 text-[#2E2E2E] font-medium mb-5">
        ข้อมูลห้องปฏิบัติการ
      </div>

      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Input
            label="ชื่อห้องปฏิบัติการ"
            placeholder="ชื่อห้องปฏิบัติการ"
            value={laboratoryName}
            setValue={setLaboratoryName}
          />
        </div>
        <div className="col-span-6">
          <Input
            label="ที่อยู่"
            placeholder="ที่อยู่ (ชื่ออาคาร ตึก หรือบ้านเลขที่)"
            value={labAddress}
            setValue={setLabAddress}
          />
          <Input
            label="ซอย"
            placeholder="ซอย"
            value={labSoy}
            setValue={setLabSoy}
          />
          <Select
            label="จังหวัด"
            placeholder="จังหวัด"
            value={labProvinceId}
            setValue={(e) => {
              setLabProvinceId(e);
              getLabDistrictList(e);
            }}
            list={labProvinceList}
          />
          <Select
            placeholder="ตำบล"
            label="ตำบล"
            disabled={disabledLabSubDistrictList}
            value={labSubDistrictId}
            setValue={setLabSubDistrictId}
            list={labSubDistrictList}
          ></Select>
        </div>
        <div className="col-span-6">
          <Input
            label="หมู่"
            placeholder="หมู่"
            value={labMoo}
            setValue={setLabMoo}
          />
          <Input
            label="ถนน"
            placeholder="ถนน"
            value={labRoad}
            setValue={setLabRoad}
          />
          <Select
            label="อำเภอ"
            placeholder="อำเภอ"
            value={labDistrictId}
            disabled={disabledLabDistrict}
            setValue={(e) => {
              setLabDistrictId(e);
              getLabSubDistrictList(e);
            }}
            list={labDistrictList}
          ></Select>
          <Input
            label="รหัสไปรษณีย์"
            regex={regex.postCode()}
            placeholder="รหัสไปรษณีย์"
            value={labPostCode}
            setValue={setLabPostCode}
          ></Input>
        </div>
      </div>

      <div className="text-[16px] leading-6 text-[#2E2E2E] font-medium mb-5">
        ตำแหน่งที่ตั้ง
      </div>

      <div className="text-[16px] text-[#000000]">
        <div>
          กรุณารอสักครู่เพื่อให้แผนที่แสดงที่ตั้งปัจจุบันของท่าน
          จากนั้นให้ปักหมุดบนตำแหน่งห้องปฏิบัติการของท่าน
          หรือค้นหาละติจูดและลองจิจูดจาก https://www.google.com/maps
        </div>
      </div>

      <div className="col-span-12 h-[400px]">
        <Map
          latitude={latitude}
          longitude={longitude}
          onChange={(e) => {
            setLatitude(e.lat);
            setLongitude(e.lng);
          }}
        />
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-6">
            <Input
                label="Latitude"
                disabled='true'
                placeholder={"latitude"}
                value={latitude}
                setValue={setLatitude}
            />
        </div>
        <div className="col-span-6">
            <Input
                label="Longitude"
                disabled='true'
                placeholder={"longitude"}
                value={longitude}
                setValue={setLongitude}
            />
        </div>
      </div>
    </div>
  );
};

export default LaboratoryRegistration;
